// extracted by mini-css-extract-plugin
module.exports = {"error-image":"style_error-image__3BobC","error-text":"style_error-text__Sy7dc","error-container":"style_error-container__5A46C","search-title":"style_search-title__I8Q1y"};